import { VisualizerPage } from '../flowVisualiser/visualizer';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';

export const InsightsPage = () => {
  return (
    <NuqsAdapter>
      <VisualizerPage />
    </NuqsAdapter>
  );
};
